var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "inner-card", style: { background: _vm.backgroundColor } },
    [
      _c("ValidationObserver", {
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ handleSubmit }) {
              return [
                _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _vm._l(_vm.interviewStatus, function (item, index) {
                      return [
                        _c(
                          "div",
                          { key: "Company" + index, staticClass: "col-md-12" },
                          [
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("ValidationProvider", {
                                  attrs: {
                                    name: `公司名稱${index}`,
                                    rules: "required",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors }) {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "field-title" },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "mark" },
                                                  [_vm._v("*")]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    style: {
                                                      color: _vm.fontColor,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(" 公司名稱 "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "en-text",
                                                      },
                                                      [_vm._v("Company's name")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "field-value" },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: item.Company,
                                                      expression:
                                                        "item.Company",
                                                    },
                                                  ],
                                                  attrs: {
                                                    type: "text",
                                                    maxlength: "200",
                                                    autocomplete: "off",
                                                    readonly: "",
                                                  },
                                                  domProps: {
                                                    value: item.Company,
                                                  },
                                                  on: {
                                                    focus: function ($event) {
                                                      return _vm.$common.removeReadonly(
                                                        $event
                                                      )
                                                    },
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        item,
                                                        "Company",
                                                        $event.target.value
                                                      )
                                                    },
                                                  },
                                                }),
                                              ]
                                            ),
                                            errors[0]
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(errors[0]) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            key: "IndustryCategory" + index,
                            staticClass: "col-md-6",
                          },
                          [
                            _c("div", { staticClass: "field" }, [
                              _c("div", { staticClass: "field-title" }, [
                                _c(
                                  "span",
                                  { style: { color: _vm.fontColor } },
                                  [
                                    _vm._v(" 產業類別 "),
                                    _c("span", { staticClass: "en-text" }, [
                                      _vm._v("Industry category"),
                                    ]),
                                  ]
                                ),
                              ]),
                              _c(
                                "div",
                                { staticClass: "field-value" },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "w-100",
                                      attrs: { placeholder: "請選擇" },
                                      model: {
                                        value: item.IndustryCategory,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            item,
                                            "IndustryCategory",
                                            $$v
                                          )
                                        },
                                        expression: "item.IndustryCategory",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: {
                                          label:
                                            "電子產業 (Electronics Industry)",
                                          value: 0,
                                        },
                                      }),
                                      _c("el-option", {
                                        attrs: {
                                          label:
                                            "封測產業 (Semi-conductors Industry)",
                                          value: 1,
                                        },
                                      }),
                                      _c("el-option", {
                                        attrs: {
                                          label:
                                            "傳統產業 (Traditional Industries)",
                                          value: 2,
                                        },
                                      }),
                                      _c("el-option", {
                                        attrs: {
                                          label: "其他產業 (Other Industries)",
                                          value: 3,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            key: "InterviewDate" + index,
                            staticClass: "col-md-6",
                          },
                          [
                            _c("div", { staticClass: "field" }, [
                              _c("div", { staticClass: "field-title" }, [
                                _c(
                                  "span",
                                  { style: { color: _vm.fontColor } },
                                  [
                                    _vm._v(" 面試日期 "),
                                    _c("span", { staticClass: "en-text" }, [
                                      _vm._v("Application date"),
                                    ]),
                                  ]
                                ),
                              ]),
                              _c(
                                "div",
                                { staticClass: "field-value" },
                                [
                                  _c("el-date-picker", {
                                    staticClass: "w-100",
                                    attrs: {
                                      type: "date",
                                      "value-format": "yyyy-MM-dd",
                                      placeholder: "YYYY-MM-DD",
                                    },
                                    model: {
                                      value: item.InterviewDate,
                                      callback: function ($$v) {
                                        _vm.$set(item, "InterviewDate", $$v)
                                      },
                                      expression: "item.InterviewDate",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          { key: "County" + index, staticClass: "col-md-6" },
                          [
                            _c("div", { staticClass: "field" }, [
                              _c("div", { staticClass: "field-title" }, [
                                _c(
                                  "span",
                                  { style: { color: _vm.fontColor } },
                                  [
                                    _vm._v(" 縣市 "),
                                    _c("span", { staticClass: "en-text" }, [
                                      _vm._v("Location (City)"),
                                    ]),
                                  ]
                                ),
                              ]),
                              _c(
                                "div",
                                { staticClass: "field-value" },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "w-100",
                                      attrs: {
                                        filterable: "",
                                        placeholder: "請選擇",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.changeCounty($event, index)
                                        },
                                      },
                                      model: {
                                        value: item.CountyGuid,
                                        callback: function ($$v) {
                                          _vm.$set(item, "CountyGuid", $$v)
                                        },
                                        expression: "item.CountyGuid",
                                      },
                                    },
                                    _vm._l(_vm.cityOptions, function (city) {
                                      return _c("el-option", {
                                        key: city.Guid,
                                        attrs: {
                                          label: city.Name,
                                          value: city.Guid,
                                        },
                                      })
                                    }),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          { key: "District" + index, staticClass: "col-md-6" },
                          [
                            _c("div", { staticClass: "field" }, [
                              _c("div", { staticClass: "field-title" }, [
                                _c(
                                  "span",
                                  { style: { color: _vm.fontColor } },
                                  [
                                    _vm._v(" 區域 "),
                                    _c("span", { staticClass: "en-text" }, [
                                      _vm._v("Location (District)"),
                                    ]),
                                  ]
                                ),
                              ]),
                              _c(
                                "div",
                                { staticClass: "field-value" },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "w-100",
                                      attrs: {
                                        filterable: "",
                                        placeholder: "請先選擇縣市",
                                      },
                                      model: {
                                        value: item.DistrictGuid,
                                        callback: function ($$v) {
                                          _vm.$set(item, "DistrictGuid", $$v)
                                        },
                                        expression: "item.DistrictGuid",
                                      },
                                    },
                                    _vm._l(
                                      item.districtOptions,
                                      function (district) {
                                        return _c("el-option", {
                                          key: district.Guid,
                                          attrs: {
                                            label: district.Name,
                                            value: district.Guid,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          { key: "Position" + index, staticClass: "col-md-6" },
                          [
                            _c("div", { staticClass: "field" }, [
                              _c("div", { staticClass: "field-title" }, [
                                _c(
                                  "span",
                                  { style: { color: _vm.fontColor } },
                                  [
                                    _vm._v(" 面試職務 "),
                                    _c("span", { staticClass: "en-text" }, [
                                      _vm._v("Applied occupation"),
                                    ]),
                                  ]
                                ),
                              ]),
                              _c("div", { staticClass: "field-value" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: item.Position,
                                      expression: "item.Position",
                                    },
                                  ],
                                  attrs: {
                                    type: "text",
                                    maxlength: "50",
                                    autocomplete: "off",
                                    readonly: "",
                                  },
                                  domProps: { value: item.Position },
                                  on: {
                                    focus: function ($event) {
                                      return _vm.$common.removeReadonly($event)
                                    },
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        item,
                                        "Position",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            key: "InterviewResult" + index,
                            staticClass: "col-md-6",
                          },
                          [
                            _c("div", { staticClass: "field" }, [
                              _c("div", { staticClass: "field-title" }, [
                                _c(
                                  "span",
                                  { style: { color: _vm.fontColor } },
                                  [
                                    _vm._v(" 面試結果 "),
                                    _c("span", { staticClass: "en-text" }, [
                                      _vm._v("Application result"),
                                    ]),
                                  ]
                                ),
                              ]),
                              _c(
                                "div",
                                { staticClass: "field-value" },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "w-100",
                                      attrs: { placeholder: "請選擇" },
                                      model: {
                                        value: item.InterviewResult,
                                        callback: function ($$v) {
                                          _vm.$set(item, "InterviewResult", $$v)
                                        },
                                        expression: "item.InterviewResult",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: {
                                          label: "錄取 (Select)",
                                          value: 0,
                                        },
                                      }),
                                      _c("el-option", {
                                        attrs: {
                                          label: "不錄取 (Ineligible)",
                                          value: 1,
                                        },
                                      }),
                                      _c("el-option", {
                                        attrs: {
                                          label: "未通知 (No notice)",
                                          value: 2,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            key: "BasicSalary" + index,
                            staticClass: "col-md-6",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("ValidationProvider", {
                                  staticClass: "w-100",
                                  attrs: {
                                    name: `底薪${index}`,
                                    rules: { regex: new RegExp(/^([0-9,]+)$/) },
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors }) {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "field-title" },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    style: {
                                                      color: _vm.fontColor,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(" 底薪 "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "en-text",
                                                      },
                                                      [_vm._v("Basic salary")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "field-value" },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model.trim",
                                                      value: item.BasicSalary,
                                                      expression:
                                                        "item.BasicSalary",
                                                      modifiers: { trim: true },
                                                    },
                                                  ],
                                                  attrs: { type: "text" },
                                                  domProps: {
                                                    value: item.BasicSalary,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        item,
                                                        "BasicSalary",
                                                        $event.target.value.trim()
                                                      )
                                                    },
                                                    blur: function ($event) {
                                                      return _vm.$forceUpdate()
                                                    },
                                                  },
                                                }),
                                              ]
                                            ),
                                            errors
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(errors[0]) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          { key: "Allowance" + index, staticClass: "col-md-6" },
                          [
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("ValidationProvider", {
                                  staticClass: "w-100",
                                  attrs: {
                                    name: `津貼${index}`,
                                    rules: { regex: new RegExp(/^([0-9,]+)$/) },
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors }) {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "field-title" },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    style: {
                                                      color: _vm.fontColor,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(" 津貼 "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "en-text",
                                                      },
                                                      [_vm._v("Allowance")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "field-value" },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model.trim",
                                                      value: item.Allowance,
                                                      expression:
                                                        "item.Allowance",
                                                      modifiers: { trim: true },
                                                    },
                                                  ],
                                                  attrs: { type: "text" },
                                                  domProps: {
                                                    value: item.Allowance,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        item,
                                                        "Allowance",
                                                        $event.target.value.trim()
                                                      )
                                                    },
                                                    blur: function ($event) {
                                                      return _vm.$forceUpdate()
                                                    },
                                                  },
                                                }),
                                              ]
                                            ),
                                            errors
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(errors[0]) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            key: "YearlySalary" + index,
                            staticClass: "col-md-6",
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("ValidationProvider", {
                                  staticClass: "w-100",
                                  attrs: {
                                    name: `年薪${index}`,
                                    rules: { regex: new RegExp(/^([0-9,]+)$/) },
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors }) {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "field-title" },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    style: {
                                                      color: _vm.fontColor,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(" 年薪 "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "en-text",
                                                      },
                                                      [_vm._v("Yearly Income")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "field-value" },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model.trim",
                                                      value: item.YearlySalary,
                                                      expression:
                                                        "item.YearlySalary",
                                                      modifiers: { trim: true },
                                                    },
                                                  ],
                                                  attrs: { type: "text" },
                                                  domProps: {
                                                    value: item.YearlySalary,
                                                  },
                                                  on: {
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        item,
                                                        "YearlySalary",
                                                        $event.target.value.trim()
                                                      )
                                                    },
                                                    blur: function ($event) {
                                                      return _vm.$forceUpdate()
                                                    },
                                                  },
                                                }),
                                              ]
                                            ),
                                            errors
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(errors[0]) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _vm.interviewStatus.length > 1
                          ? _c(
                              "div",
                              {
                                key: "button" + index,
                                staticClass: "col-md-6",
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "del-btn",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.del(index)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("BUTTON.RESUME_DELETE")) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    }),
                  ],
                  2
                ),
                _c("div", { staticClass: "edit-btn-wrap" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn-sm add-btn",
                      attrs: { type: "button" },
                      on: { click: _vm.add },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("BUTTON.RESUME_ADD")) + " ")]
                  ),
                  _c(
                    "button",
                    {
                      staticClass: "put-btn",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return handleSubmit(_vm.saveInterviewStatus)
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("BUTTON.RESUME_SAVE")) + " ")]
                  ),
                ]),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }